import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './AdvisorPanel_PatientDataLoader.scss';
import { AdvisorPanel } from '../AdvisorPanel/AdvisorPanel.js';
import { PanelKey_PatientDataLoader } from '../../../_shared.js';
import { _className, TS_ButtonLoader } from '@nu-art/thunderstorm-frontend/index';
export class AdvisorPanel_PatientDataLoader extends AdvisorPanel {
    //######################### Static #########################
    static defaultProps = {
        panelKey: PanelKey_PatientDataLoader,
    };
    //######################### Life Cycle #########################
    //######################### Logic #########################
    getPanelClass() {
        return _className(super.getPanelClass(), PanelKey_PatientDataLoader);
    }
    onPanelClick = undefined;
    //######################### Render #########################
    renderFooter = undefined;
    renderSubHeader = undefined;
    renderContent = () => undefined;
    renderHeader_Title = () => {
        return _jsxs(_Fragment, { children: ["Loading Patient Data ", _jsx(TS_ButtonLoader, {})] });
    };
    renderHeader_Tail = undefined;
}
//# sourceMappingURL=AdvisorPanel_PatientDataLoader.js.map